var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, makeObservable, observable } from 'mobx';
export default class LogInStore {
    constructor(rootStore) {
        Object.defineProperty(this, "flashLoginOptions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "customerSearchPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: '/web/teenindus/otsing'
        });
        Object.defineProperty(this, "handleClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event) => {
                const { authData } = this.rootStore.ssoStore;
                const { setSection } = this.rootStore.sectionStore;
                const { URLData } = this.rootStore.environmentStore;
                event.preventDefault();
                if (authData.isDealer) {
                    if (!authData.customer) {
                        setSection(null);
                        const searchURL = URLData.getSelfServiceURL(this.customerSearchPath);
                        window.location.assign(searchURL);
                    }
                }
                else {
                    if (!authData.isLoggedIn) {
                        this.rootStore.ssoStore.setLoginCallback(() => this.doRedirect());
                    }
                }
            }
        });
        Object.defineProperty(this, "triggerChatApiLogin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { lang } = this.rootStore.environmentStore;
                const { section, setSection } = this.rootStore.sectionStore;
                if (section === 'sso') {
                    return false;
                }
                this.flashLoginOptions = {
                    authLevel: 2,
                    selectMandate: true,
                    locale: lang
                };
                setSection('sso');
                return true;
            }
        });
        Object.defineProperty(this, "initializeChatApi", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { URLData } = this.rootStore.environmentStore;
                const ssoStore = this.rootStore.ssoStore;
                window.telia = {
                    ...window.telia,
                    chatApi: {
                        getApiUrl: () => URLData.getPublicURL('/chat/api'),
                        triggerLogin: this.triggerChatApiLogin,
                        isLoggedIn: () => ssoStore.authData.authLevel === 2 || ssoStore.authData.isDealer
                    }
                };
            }
        });
        Object.defineProperty(this, "isPublicApp", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return this.rootStore.environmentStore.app === 'public';
            }
        });
        Object.defineProperty(this, "isOnPublicRoot", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const getLocalizedPath = this.rootStore.environmentStore.URLData.getLocalizedPath;
                const { currentPath } = this.rootStore.locationStore;
                return ['/', '/era', '/ari'].some((path) => getLocalizedPath(path) === currentPath);
            }
        });
        Object.defineProperty(this, "doRedirect", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { authData } = this.rootStore.ssoStore;
                const { URLData } = this.rootStore.environmentStore;
                if (authData.isLoggedIn && !authData.isDealer && this.shouldRedirectToSelfService()) {
                    window.location.assign(URLData.selfServiceURL);
                }
                else if (authData.isDealer && this.isOnPublicRoot()) {
                    window.location.assign(URLData.selfServiceURL.concat('/web/teenindus'));
                }
            }
        });
        Object.defineProperty(this, "shouldRedirectToSelfService", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return this.isPublicApp() && this.isOnPublicRoot();
            }
        });
        makeObservable(this);
        this.rootStore = rootStore;
        this.initializeChatApi();
    }
    get loginOptions() {
        const { authData, loginOptions } = this.rootStore.ssoStore;
        const { lang } = this.rootStore.environmentStore;
        if (this.flashLoginOptions) {
            return this.flashLoginOptions;
        }
        if (loginOptions) {
            return loginOptions;
        }
        if (authData.isLoggedIn) {
            return {
                selectMandate: true,
                authLevel: 0,
                locale: lang
            };
        }
        return {
            selectMandate: true,
            authLevel: this.rootStore.ssoStore.disableSoftAuth ? 2 : 1,
            locale: lang
        };
    }
    get loginUrl() {
        const { getLoginURL } = this.rootStore.ssoStore;
        const { skipSsoModule } = this.rootStore.environmentStore;
        return this.isDealerWithRepresentative ? this.getDealerMandateSelectUrl(!skipSsoModule) : getLoginURL(this.loginOptions, !skipSsoModule);
    }
    get ssoLinkUrl() {
        const { URLData } = this.rootStore.environmentStore;
        const { authData } = this.rootStore.ssoStore;
        if (authData.isDealer && !authData.customer) {
            return URLData.getSelfServiceURL(this.customerSearchPath);
        }
        const goto = this.shouldRedirectToSelfService() ? URLData.selfServiceURL : window.location.href;
        return URLData.ssoBackendLink({ ...this.loginOptions, goto });
    }
    getDealerMandateSelectUrl(ignoreBackendUri = false) {
        return `${!ignoreBackendUri ? this.rootStore.environmentStore.URLData.ssoBackendURL : ''}/admin/mandates`;
    }
    get isDealerWithRepresentative() {
        const { authData } = this.rootStore.ssoStore;
        return authData.isDealer && authData.customer;
    }
}
__decorate([
    observable
], LogInStore.prototype, "flashLoginOptions", void 0);
__decorate([
    action
], LogInStore.prototype, "handleClick", void 0);
__decorate([
    computed
], LogInStore.prototype, "loginOptions", null);
__decorate([
    computed
], LogInStore.prototype, "loginUrl", null);
__decorate([
    computed
], LogInStore.prototype, "ssoLinkUrl", null);
__decorate([
    computed
], LogInStore.prototype, "isDealerWithRepresentative", null);
//# sourceMappingURL=LogInStore.js.map